import type { GridRenderCellParams } from "@mui/x-data-grid";
import { OnboardingApplicationStatus as OnboardingApplicationStatusComponent } from "ui/molecules/Status";
import { OnboardingApplicationStatus } from "consts/onboarding";

const ApplicationStatus = ({ value }: GridRenderCellParams<OnboardingApplicationStatus>) => (
    <OnboardingApplicationStatusComponent
        label={value}
    />
);

export default ApplicationStatus;
